<template>
  <div class="content">
    <div class="content_swipe">
      <van-swipe :loop="true" indicator-color="#fff" @change="onChange">
        <van-swipe-item v-if="videoList.length > 0">
          <video-player
            class="video"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          >
          </video-player>
        </van-swipe-item>
        <van-swipe-item
          v-for="(image, index) in imageList"
          :key="'img' + index"
        >
          <img class="swipe_img" :src="image" />
        </van-swipe-item>
        <template #indicator>
          <div
            v-if="videoList.length > 0 && swipeIndex == 0"
            class="custom-indicator"
          >
            视频
          </div>
          <div v-else class="custom-indicator">
            {{ videoList.length > 0 ? swipeIndex : swipeIndex + 1 }}/{{
              imageList.length
            }}
          </div>
        </template>
      </van-swipe>
    </div>
    <div class="content-wrapper-below">
      <div class="base_info">
        <!-- 标签 -->
        <div class="title">
          <img
            v-if="attrib.property_status == 1"
            src="../../assets/house/saleing_tip_detail.png"
            class="title_tip"
            alt=""
          />
          <img
            v-if="attrib.property_status == -1"
            src="../../assets/house/forSale_tip_detail.png"
            class="title_tip"
            alt=""
          />
          <img
            v-if="attrib.property_status == -2"
            src="../../assets/house/soldOut_detail.png"
            class="title_tip"
            alt=""
          />
          <span class="title_txt">{{ houseDetailData.title }}</span>
        </div>

        <div class="house_info">
          <div class="house_info_item">
            <span class="house_info_item_key">均价：</span>
            <span
              class="house_info_item_val house_info_item_val_color"
              v-if="houseDetailData.is_face == -1"
              >{{ houseDetailData.price }}元/㎡</span
            >
            <span
              class="house_info_item_val house_info_item_val_color"
              v-if="houseDetailData.is_face == 1"
              >待定</span
            >
          </div>
          <div class="house_info_item">
            <span class="house_info_item_key">建面：</span>
            <span class="house_info_item_val"
              >{{ houseDetailData.size }}-{{ houseDetailData.max_size }}㎡</span
            >
          </div>
          <div class="house_info_item">
            <span class="house_info_item_key">地区：</span>
            <span class="house_info_item_val"
              >{{ houseDetailData.province }}{{ houseDetailData.city
              }}{{
                houseDetailData.district ? houseDetailData.district : ''
              }}</span
            >
          </div>
          <div class="house_info_item">
            <span class="house_info_item_key">类型：</span>
            <span class="house_info_item_val house_info_item_val_width">{{
              houseDetailData.house_type &&
                houseDetailData.house_type.join('，')
            }}</span>
          </div>
        </div>

        <div class="introduce">
          <div
            class="introduce_item"
            v-for="(item, index) in houseDetailData.introduce"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>

      <div class="building_info">
        <div class="building_info_title">楼盘信息</div>
        <div class="house_info_item">
          <span class="house_info_item_key">物业：</span>
          <span class="house_info_item_val">{{ attrib.property_company }}</span>
        </div>
        <div class="house_info_item">
          <span class="house_info_item_key">产权：</span>
          <span class="house_info_item_val"
            >{{ houseDetailData.property }}年</span
          >
        </div>
        <div class="house_info_item">
          <span class="house_info_item_key">楼栋：</span>
          <span class="house_info_item_val">{{ attrib.building }}</span>
        </div>
        <div class="house_info_item">
          <span class="house_info_item_key">开盘时间：</span>
          <span
            class="house_info_item_val"
            v-if="attrib.open_time == '' || attrib.open_time == null"
            >待定</span
          >
          <span class="house_info_item_val" v-else>{{
            attrib.open_time.split(' ')[0]
          }}</span>
        </div>
        <div class="house_info_item">
          <span class="house_info_item_key">开发商：</span>
          <span class="house_info_item_val">{{ attrib.developer }}</span>
        </div>
      </div>

      <div class="building_info">
        <div class="building_info_title">总规划图</div>
        <div class="plan_swipe">
          <van-swipe :loop="true" indicator-color="#fff" @change="onChangePlan">
            <van-swipe-item
              v-for="(image, index) in houseDetailData.image &&
                houseDetailData.image.other"
              :key="'img' + index"
            >
              <img class="plan_img" :src="image" />
            </van-swipe-item>
            <template #indicator>
              <div class="plan-indicator">
                <div
                  class="indicatorItem"
                  v-for="(item, index) in houseDetailData.image &&
                    houseDetailData.image.other"
                  :key="index"
                  :class="[
                    index == planSwipeIndex ? 'activeindicatorItem' : '',
                  ]"
                ></div>
              </div>
            </template>
          </van-swipe>
        </div>
      </div>
      <div class="building_info">
        <div class="building_info_title">热门户型</div>
        <div class="layout_scroll">
          <div
            class="layout_scroll_item"
            v-for="(item, index) in houseDetailData.layout"
            :key="index"
          >
            <img class="layout_scroll_item_img" :src="item.picture[0]" alt="" />
            <div class="layoutScro_item_room">
              户型：{{ item.room }}室{{ item.office }}厅{{ item.toilet }}卫
            </div>
            <div class="layoutScro_item_row">
              <div class="layoutScro_item_row_txt">建面{{ item.size }}㎡</div>
              <div class="layoutScro_item_row_txt">
                朝向：{{ item.orientation }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="building_info"
        v-if="houseDetailData.dynamic && houseDetailData.dynamic.length != 0"
      >
        <div class="building_info_title">楼盘动态</div>
        <div class="dynamic_content">
          {{ houseDetailData.dynamic && houseDetailData.dynamic[0].content }}
        </div>
        <img
          class="dynamic_img"
          :src="
            houseDetailData.dynamic &&
              houseDetailData.dynamic[0].dynamic_picture[0]
          "
        />
      </div>
      <div class="building_info1">
        <div class="building_info_title">楼盘位置</div>
        <div class="map">
          <img
            src="../../assets/house/position@2x.png"
            class="map_icon"
            alt=""
          />
          <div class="map_position">
            <div class="map_position_address">
              {{ houseDetailData.location_address }}
            </div>
          </div>
        </div>
      </div>
      <div class="building_periphery">
        <div class="building_info_title">周边配套</div>
        <div
          class="facilitie_item"
          v-for="(item, index) in facilitie"
          :key="index"
        >
          <div class="facilitie_item_title">{{ item.title }}</div>
          <div class="facilitie_item_content">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <div v-if="isWeixin || isQQ" class="share" @click="open_mask()">
      立即咨询
    </div>
    <div v-else class="share" @click="open_app()">立即咨询</div>
    <div class="weixin-tip" v-if="maskShow">
      <p>
        <img
          v-if="!isIOS"
          src="../../assets/common/live_weixin.png"
          alt="微信打开"
        />
        <img
          v-if="isIOS"
          src="../../assets/common/live_weixin_ios.png"
          alt="微信打开"
        />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: '',
      houseDetailData: {},
      imageList: [],
      videoList: [],
      swipeIndex: 0,
      planSwipeIndex: 0,
      attrib: {},
      facilitie: [],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: true, //如果true,则自动播放
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 循环播放
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。

        sources: [
          {
            // 播放资源和资源格式
            type: 'video/mp4',
            src: '', //你的视频地址（先为空，之后动态赋值）
          },
        ],
        poster: '', //视频封面图
        width: document.documentElement.clientWidth, // 默认视频全屏时的最大宽度
        notSupportedMessage: '加载中...', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      },
      isIOS: false,
      isWeixin: false,
      isQQ: false,
      maskShow: false,
    }
  },
  created() {
    this.id = this.$route.query.id
    var u = navigator.userAgent
    this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1 // 微信内
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    if (
      u.toLowerCase().indexOf('qq') > -1 &&
      u.toLowerCase().indexOf('mqqbrowser') < 0 &&
      this.isIOS
    ) {
      //qq内置浏览器
      this.isQQ = true
    }
    this.getHouseDetail()
  },
  methods: {
    getHouseDetail() {
      this.$api
        .get('estate/index/new/estates/detail', {
          id: this.id,
          source: 1,
        })
        .then((res) => {
          if (res) {
            this.houseDetailData = res
            this.attrib = res.attrib
            this.facilitie = res.facilitie
            this.facilitie.forEach((item) => {
              if (item.content.length >= 200) {
                item.open = false
              } else {
                item.open = true
              }
              this.facilitie = [...this.facilitie]
            })
            this.addImgs()
          }
        })
    },
    addImgs() {
      if (
        this.houseDetailData.image.video != null &&
        this.houseDetailData.image.video.length != 0
      ) {
        this.houseDetailData.image.video.forEach((item) => {
          this.videoList.push(item)
        })
        this.playerOptions['sources'][0][
          'src'
        ] = this.houseDetailData.image.video[0]
      }
      this.houseDetailData.image.living_room.forEach((item) => {
        this.imageList.push(item)
      })
      this.houseDetailData.image.other.forEach((item) => {
        this.imageList.push(item)
      })
    },
    onChange(index) {
      if (this.videoList.length > 0) {
        this.$refs.videoPlayer.player.pause()
      }
      this.swipeIndex = index
    },
    onChangePlan(index) {
      this.planSwipeIndex = index
    },
    open_mask() {
      this.maskShow = true
    },
    open_app() {
      let baseUrl = process.env.VUE_APP_WEEX_HOST
      this.parmSrc = `house/index?house_js=${baseUrl}/newHouseDetail.js?id=${this.id}&baseUrl=${baseUrl}`
      this.openApp('', '', this.parmSrc)
    },
  },
}
</script>

<style lang="less" scoped>
.content-wrapper-below {
  width: 375px;
  position: absolute;
  background-color: rgba(245, 245, 245, 1);
  padding-right: 16px;
}

.base_info {
  padding: 20px 16px 1px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: rgba(255, 255, 255, 1);
  margin-top: -12px;
}

.content {
  box-sizing: border-box;
  font-size: 14px;
  color: #333;
  overflow: auto;
  background-color: rgba(246, 246, 246, 1);
}

.content_swipe {
  width: 100%;
  height: 282px;

  .van-swipe,
  .swipe_img,
  .video {
    width: 100%;
    height: 100%;
  }
}

/deep/.vjs-tech {
  height: 282px;
}

/deep/.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  height: 282px;
}

/deep/.video-js .vjs-big-play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.custom-indicator {
  position: absolute;
  right: 16px;
  bottom: 28px;
  width: 55px;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  font-weight: 600;
  border-radius: 17px;
  background-color: rgba(0, 0, 0, 0.2);
}

.content-wrapper {
  background-color: rgba(255, 255, 255, 1);
  padding: 20px 16px 0;
}

.title {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title_tip {
  width: 32px;
  margin-right: 5px;
}

.title_txt {
  font-size: 20px;
  font-weight: bold;
  color: #222325;
}

.introduce {
  display: flex;
  flex-direction: row;
  margin-top: 12px;
  margin-bottom: 21px;
}

.introduce_item {
  height: 20px;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  background: #eef8ff;
  border-radius: 2px;
  font-size: 12px;
  color: #7594b7;
}

.house_info {
  margin-top: 16px;
}

.house_info_item {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}

.house_info_item_key {
  font-size: 14px;
  color: #afb3bc;
}

.house_info_item_val {
  font-size: 14px;
  color: #222325;
}

.house_info_item_val_color {
  color: #e94b4b;
}

.house_info_item_val_width {
  display: block;
  max-width: 280px;
}

.building_info {
  padding: 20px 16px 16px;
  background-color: rgba(255, 255, 255, 1);
  margin-top: 8px;
}

.building_info1 {
  padding: 20px 16px 1px;
  background-color: rgba(255, 255, 255, 1);
  margin-top: 8px;
}

.building_periphery {
  padding: 20px 16px 16px;
  background-color: rgba(255, 255, 255, 1);
  margin-top: 16px;
  padding-bottom: 70px;
}

.building_info_title {
  font-size: 17px;
  font-weight: bold;
  color: #222325;
  margin-bottom: 16px;
}

.plan_swipe {
  width: 100%;
  height: 155px;
  position: relative;

  .van-swipe,
  .plan_img {
    width: 100%;
    height: 100%;
  }
}

.plan-indicator {
  display: flex;
  flex-direction: row;
  justify-content: flex-Wstart;
  align-items: center;
  position: relative;
  left: 50%;
  bottom: 9px;
  transform: translateX(-50%);
}

.indicatorItem {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.36);
  margin-left: 4px;
}

.activeindicatorItem {
  width: 9px;
  height: 4px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  margin-left: 4px;
}

.layout_scroll {
  width: 100%;
  height: 250px;
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
}

.layout_scroll_item {
  flex: 0 0 188px;
  height: 100%;
  // background-color: royalblue;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
}

.layout_scroll_item:last-child {
  margin-right: 0;
}

.layout_scroll_item_img {
  width: 188px;
  height: 183px;
  display: block;
}

.layoutScro_item_room {
  font-size: 16px;
  font-weight: bold;
  color: #222325;
  margin-top: 14px;
}

.layoutScro_item_row {
  display: flex;
  flex-direction: row;
  margin: 6px 0;
}

.layoutScro_item_row_txt {
  font-size: 12px;
  color: #6d7177;
  margin-right: 16px;
}

.dynamic_content {
  width: 100%;
  font-size: 16px;
  color: #222325;
  line-height: 23px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.dynamic_img {
  width: 100%;
  height: 155px;
  border-radius: 6px;
  margin-top: 12px;
}

.map {
  padding: 0 14px;
  height: 62px;
  margin-bottom: 20px;
  background: #fafbfd;
  border-radius: 2px;
  border: 1px solid #eef2fb;
  display: flex;
  align-items: center;

  .map_icon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }

  .map_position {
    display: flex;
    flex-direction: column;

    .map_position_address {
      font-size: 14px;
      color: #333333;
      font-weight: bold;
    }
  }
}

.facilitie_item {
  margin-bottom: 16px;
}

.facilitie_item_title {
  font-size: 16px;
  color: #222325;
  font-weight: 400;
  margin-bottom: 8px;
}

.facilitie_item_content {
  width: 100%;
  font-size: 12px;
  color: #6d7177;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.share {
  width: 222px;
  height: 40px;
  position: fixed;
  bottom: 39px;
  left: 50%;
  transform: translateX(-50%);
  background: #26c165;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #ffffff;
}

.weixin-tip {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);

  p {
    padding: 15px 25px;

    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
